import './Blog.css';
import { useScrollReveal } from '../../../useScrollReveal';

const Blog = (props) => {
    const { ref, style } = useScrollReveal();

    return (
        <a className="Blog" href={props.redirectUrl} target="_blank" rel="noreferrer" ref={ref} style={style}>
            <div className="image">
                <img src={props.imageUrl} alt="Blog"/>
            </div>
            <div className="title">
                {props.title}
            </div>
        </a>
    );
};

export default Blog;
